import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  coachingListing,
  providerCoaching,
  providerCoachingClear,
} from "../../../redux/provider/actions";
import { SessionKeys } from "../../../utils/AppUtils";
import _ from "lodash";
import Loader from "../../../components/Loader/Loader";
import SuggestedCoaches from "../SuggestedCoaches/SuggestedCoaches";
import { getAllSkills, getCoachingListing, getCoachingListingClear } from "../../../redux/coaching/actions";
import { getCityList } from "../../../redux/user/actions";
import API_LIST from "../../../utils/apiList";
import CONFIG from "../../../utils/config";
import Page from "../../../components/Page";
import CoachingListing from "../../../components/NewDesign/Halifax/Coaching/Listing/CoachingListing";

const ViewCoaches = () => {

  // let dispatch = useDispatch();

  // const providerCoachingResponse = useSelector(
  //   (state) => state.provider.providerCoachingResponse
  // );
  // const coachingListingRes = useSelector(
  //   (state) => state.provider.coachingListing
  // );

  // const [selectedSort, setSelectedSort] = useState(1);
  // const [headerProdData, setHeaderProdData] = useState({});
  // const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // const [coachesData, setCoachesData] = useState([]);
  // const [searchText, setSearchText] = useState("");
  // const [coachingListing, setCoachingListing] = useState([]);
  // const [fitlersData, setFitlersData] = useState([]);


  // useEffect(() => {
  //   setIsLoading(true);
  //   callAPI();
  //   return () => {
  //     dispatch(providerCoachingClear());
  //   };
  // }, []);

  // useEffect(() => {
  //   console.log("cte--", providerCoachingResponse);
  //   if (!_.isEmpty(providerCoachingResponse)) {
  //     if (providerCoachingResponse.status === "success") {
  //       const listData = providerCoachingResponse?.payload?.data?.data?.List;
  //       setCoachesData(listData);
  //     } else {
  //       setCoachesData([]);
  //     }
  //     setIsLoading(false)
  //   }
  // }, [providerCoachingResponse]);

  

  return (
    // <Page>
    <>
    {/* <Loader start={isLoading} /> */}
      <CoachingListing 
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      {/* <SuggestedCoaches
        coachesData={coachesData}
        isLoading={isLoading}
      /> */}
    {/* </Page> */}
    </>
      
  );
};

export default ViewCoaches;
